import React from "react";
import { parseLocalDate } from "../../utils/dateUtils";

export default function DayPopover({
  dateStr,
  dayData,
  onClose,
  onDoubleClick,
}) {
  const dateObj = parseLocalDate(dateStr) || new Date();
  const formattedDate = dateObj.toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <div className="day-popover-overlay" onClick={onClose}>
      <div className="day-popover" onClick={(e) => e.stopPropagation()}>
        <div className="popover-header">
          <span className="popover-date">{formattedDate}</span>
          <button className="popover-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {dayData?.type === "HOLIDAY" && (
          <div className="popover-status holiday">
            🏖 Public Holiday · {dayData.holidayName}
          </div>
        )}
        {dayData?.type === "WEEKLY_OFF" && (
          <div className="popover-status weekly-off">Weekly Off</div>
        )}

        {dayData?.tasks?.length > 0 ? (
          <div className="popover-tasks">
            {dayData.tasks.map((task) => (
              <div key={task.id} className="popover-task-row">
                <span className="popover-task-stage">{task.stageName}</span>
                <span className="popover-task-project">
                  {task.projectName}
                </span>
              </div>
            ))}
          </div>
        ) : (
          dayData?.type === "WORKING" && (
            <p className="popover-empty">No tasks assigned</p>
          )
        )}

        <div className="popover-actions">
          <button className="popover-action-link" onClick={onDoubleClick}>
            See week view →
          </button>
        </div>
      </div>
    </div>
  );
}
